import { render, staticRenderFns } from "./AttachmentEmail.vue?vue&type=template&id=25504d9d&scoped=true"
import script from "./AttachmentEmail.vue?vue&type=script&lang=js"
export * from "./AttachmentEmail.vue?vue&type=script&lang=js"
import style0 from "./AttachmentEmail.vue?vue&type=style&index=0&id=25504d9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25504d9d",
  null
  
)

export default component.exports